import { useEffect, useRef } from "react";

export const useGetHeightOfAds = (
  setAdsHeight?: React.Dispatch<React.SetStateAction<number>>
) => {
  const boxRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!boxRef.current) return;

    if (!setAdsHeight) return;

    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setAdsHeight(entry.contentRect.height);
      }
    });

    observer.observe(boxRef.current);

    return () => {
      observer.disconnect();
    };
  }, [setAdsHeight]);

  return { boxRef };
};
